// src/player/constants.ts
// Canonical deploy host — built-in posters and the player bundle live here so
// an embed on a third-party site resolves assets without extra config.
export const CANONICAL_HOST = 'https://pages.jkaindl.de/physarum';

export const PLAYER_BUNDLE_URL = `${CANONICAL_HOST}/physarum-player.js`;

/** Built-in poster URL for a preset id under the given asset base. */
export function builtinPosterUrl(id: string, assetBase: string): string {
  const base = assetBase.replace(/\/+$/, '');
  return `${base}/preset-thumbs/${id}.png`;
}
